module.exports = __webpack_public_path__ + "mine.53d822e2e0081002a78c.svg";


//////////////////
// WEBPACK FOOTER
// /Users/emrevolkanucar/Desktop/Angular/etigumus/src/assets/img/mine.svg
// module id = ../../../../../src/assets/img/mine.svg
// module chunks = main